import 'slick-carousel';
const $ =require('jquery');
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import {Modal} from 'bootstrap';

var boutons_2 = [...document.getElementsByClassName("bouton_modal_mobile_2")];
var menu_2 = document.getElementById("menu_modal_mobile_2");

if(boutons_2 && menu_2){

    console.log(boutons_2,menu_2);
    var modal_2 = new Modal(menu_2,{});
    boutons_2.forEach(bouton_2 => {
        bouton_2.addEventListener("click",function(e){
            e.preventDefault();
            modal_2.toggle();
        })
    });
} else {
    var boutons = [...document.getElementsByClassName("bouton_modal_mobile")];
    var menu = document.getElementById("menu_modal_mobile");

    console.log(boutons,menu);
    var modal = new Modal(menu,{});
    boutons.forEach(bouton => {
        bouton.addEventListener("click",function(e){
            e.preventDefault();
            modal.toggle();
        })
    });
}






$(document).ready(function () {

    console.log( $( ".slick_produits_accueil .slick-current" ).next());
    $( ".slick_produits_accueil .slick-current" ).next().addClass('slide_milieu_zoom');
    $('.categories').on('click',function(e){
        if($(this).not('.active')){
            $('.categories').removeClass('active');
            $(this).addClass('active');
            var id = $(this).attr('data-id');
            $('.liste_produits').addClass('d-none');
            $('.liste-'+ id).removeClass('d-none');
        }
    });

    $(function(){
        var next = $("#next_image_moulin");
        var prev = $("#prev_image_moulin");
        var nextAmb = $("#next_ambassadeur_slick");
        var prevAmb = $("#prev_ambassadeur_slick");
        var nextPt = $("#next_page_type_slick");
        var prevPt = $("#prev_page_type_slick");
        setTimeout(function(){
            $("#slick_moulins_melia").slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay:true,
                autoplaySpeed: 2000,
                arrows: true,
                nextArrow: next,
                prevArrow: prev,
                dots: true
            });
            $("#slick_produits_accueil").slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                nextArrow: nextAmb,
                prevArrow: prevAmb,
                dots: true,
                autoplay:true,
                autoplaySpeed: 2000,
                centerMode: true,
                centerPadding: 0,
                responsive: [
                    {
                        breakpoint: 1050,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

            $("#slick_bas_page_type").slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay:true,
                autoplaySpeed: 2000,
                arrows: true,
                nextArrow: nextAmb,
                prevArrow: prevAmb,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1050,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 780,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        },100)
    })
});

if ( $('.product__slider-main').length ) {

    var nextPagetype = $("#next_pagetype_slick");
    var prevPagetype = $("#prev_pagetype_slick");
    var $slider = $('.product__slider-main')
        .on('init', function(slick) {
            $('.product__slider-main').fadeIn(1000);
        })
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: nextPagetype,
            prevArrow: prevPagetype,
            autoplay: false,
            lazyLoad: 'ondemand',
            asNavFor: '.product__slider-thmb'
        });

    var $slider2 = $('.product__slider-thmb')
        .on('init', function(slick) {
            $('.product__slider-thmb').fadeIn(1000);
        })
        .slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            asNavFor: '.product__slider-main',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            draggable: false
        });

    //remove active class from all thumbnail slides
    $('.product__slider-thmb .slick-slide').removeClass('slick-active');

    //set active class to first thumbnail slides
    $('.product__slider-thmb .slick-slide').eq(0).addClass('slick-active');

    // On before slide change match active thumbnail to current slide
    $('.product__slider-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var mySlideNumber = nextSlide;
        $('.product__slider-thmb .slick-slide').removeClass('slick-active');
        $('.product__slider-thmb .slick-slide').eq(mySlideNumber).addClass('slick-active');
    });
}


$(document).ready(function() {
    $('h2').each(function() {
        var $h2 = $(this);
        if (!$h2.attr('data-title')) {
            $h2.attr('data-title', $h2.text());
        }
    });
});

$(document).ready(function() {
    $('.select_label').select2({
        placeholder: 'Label',
        multiple: 'true',
        allowClear: 'true',
        dropdownParent: $('.div_select1')
    });
    $('.select_label').val(null).trigger("change");

    $('.select_conditionnement').select2({
        placeholder: 'Conditionnement',
        multiple: 'true',
        allowClear: 'true',
        dropdownParent: $('.div_select2')
    });
    $('.select_conditionnement').val(null).trigger("change");

    $('.select_cereales').select2({
        placeholder: 'Céréales',
        multiple: 'true',
        allowClear: 'true',
        dropdownParent: $('.div_select3')
    });
    $('.select_cereales').val(null).trigger("change");

    $('.select_marques').select2({
        placeholder: 'Marques',
        multiple: 'true',
        allowClear: 'true',
        dropdownParent: $('.div_select4')
    });
    $('.select_marques').val(null).trigger("change");

    loadMap(dataMarkers);
});

function loadMap(data){
    var config = data.config;

    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: config.zoom,
        center: new google.maps.LatLng(config.lat, config.long),
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    var infowindow = new google.maps.InfoWindow();
    var markers = [];

    var markerCluster;
    
    data.categories[0].infos.forEach(info => {
        var isVisible = true;
        var imageicon = {
            url:  info.icon, // url
            scaledSize: new google.maps.Size(40, 54), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(25, 50) 
          };
          
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(info.lat, info.long),
            map: map,
            icon: imageicon,
            labels : info.labels,
            conditionnements : info.conditionnements,
            cereales : info.cereales,
            marques : info.marques,
        });
        
        marker.setVisible(isVisible);

        google.maps.event.addListener(marker, 'click', (function(info, marker) {
            return function() {
                infowindow.setContent(base64DecodeUtf8(info.text));
                infowindow.open(map, marker);
            };
        })(info, marker));

        markers.push(marker);
    });

    $('.select_2').change(function(e){
        displayMarkers();
    })

    function displayMarkers(){
        let filterLabel = $('.select_label').val();
        let filterConditionnement = $('.select_conditionnement').val();
        let filterCereales = $('.select_cereales').val();
        let filterMarques = $('.select_marques').val();
        if (markerCluster) {
            markerCluster.clearMarkers(); // Efface les anciens marqueurs
        }
        var markers_visibles = [];
        markers.forEach(function(marker) {
            let isVisibleLabel = false;
            if(filterLabel.length && marker.labels.length){
                marker.labels.forEach(label =>  {
                    let visible = filterLabel.includes(label);
                    if(visible){
                        isVisibleLabel = true;
                        return;
                    }
                })
            }else{
                isVisibleLabel = true;
            }

            let isVisibleConditionnement = false;
            if(filterConditionnement.length && marker.conditionnements.length){
                marker.conditionnements.forEach(label =>  {
                    let visible = filterConditionnement.includes(label);
                    if(visible){
                        isVisibleConditionnement = true;
                        return;
                    }
                })
            }else{
                isVisibleConditionnement = true;
            }

            let isVisibleCereales = false;
            if(filterCereales.length && marker.cereales.length){
                marker.cereales.forEach(label =>  {
                    let visible = filterCereales.includes(label);
                    if(visible){
                        isVisibleCereales = true;
                        return;
                    }
                })
            }else{
                isVisibleCereales = true;
            }

            
            let isVisibleMarques = false;
            if(filterMarques.length && marker.marques.length){
                marker.marques.forEach(label =>  {
                    let visible = filterMarques.includes(label);
                    if(visible){
                        isVisibleMarques = true;
                        return;
                    }
                })
            }else{
                isVisibleMarques = true;
            }

            if(isVisibleLabel && isVisibleConditionnement && isVisibleCereales && isVisibleMarques){
                markers_visibles.push(marker);
            }
            
            
            marker.setVisible(isVisibleLabel && isVisibleConditionnement && isVisibleCereales && isVisibleMarques);
        });
        
        markerCluster.addMarkers(markers_visibles)
    }

    function base64DecodeUtf8(str) {
        return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    markerCluster = new MarkerClusterer({ map, markers ,
            renderer: {
                render: ({ markers, _position: position }) => {
                    return new google.maps.Marker({
                        position: {
                            lat: position.lat(),
                            lng: position.lng(),
                        },
                        label: {
                            text: String(markers.length),
                            color: "white",
                        },
                        icon: templateUrl + "/assets/images/m4.png",
                    });
                },
            },
        });
}